<template>
  <v-card class="workspace-panel" elevation="0">
    <div class="card-title-row"><div><h2>{{ title }}</h2><p v-if="subtitle" class="card-eyebrow">{{ subtitle }}</p></div><slot name="actions" /></div>
    <slot />
  </v-card>
</template>
<script setup>
defineProps({ title: String, subtitle: String });
</script>
